export enum AccessError {
  NO_ACCESS = 'no_access_to_service',
  COULD_NOT_VALIDATE = 'could_not_validate',
}
